import React from 'react';

import useCreateJobInterviewTime from '../../../hooks/jobs/useCreateJobInterviewTime';
import {
  CreateJobInterviewDataType,
  createJobInterviewInitialValues,
  CreateJobInterviewSchema,
} from '../../../models/jobs/createJobInterview.model';
import CustomCalender from '../../Form/CustomCalender/CustomCalender';
import { FormComponent } from '../../Form/FormComponent';
import PlainModalContainer from '../PlainModalContainer';
import { useApplicantsRefresh } from '../../../context/ApplicantRefreshContext';

const CalenderModal = ({ applicantId }: { applicantId: string }) => {
  const { triggerRefresh } = useApplicantsRefresh();

  const { loading, createJobPostInterviewTime } = useCreateJobInterviewTime();
  const handleOnSubmit = (values: CreateJobInterviewDataType) => {
    createJobPostInterviewTime({ ...values, duration: '30' }, applicantId).then(
      () => {
        triggerRefresh();
      }
    );
  };

  console.log(applicantId);

  return (
    <PlainModalContainer>
      <FormComponent
        initialValues={createJobInterviewInitialValues}
        schema={CreateJobInterviewSchema}
        onSubmit={handleOnSubmit}
      >
        <CustomCalender
          id="interviewDate"
          name="interviewDate"
          isSubmitting={loading}
        />
      </FormComponent>
    </PlainModalContainer>
  );
};

export default CalenderModal;
